import { render, staticRenderFns } from "./practiceDetail.vue?vue&type=template&id=07994c99"
import script from "./practiceDetail.js?vue&type=script&lang=js&external"
export * from "./practiceDetail.js?vue&type=script&lang=js&external"
import style0 from "./practiceDetail.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "../../less/publicStyle.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports